import { CategoryEnumValue } from './CategoryEnum';

export const InventoryItemCategoryEnumValue = {
  NoCategory: 0,
  MerchandisingTooling: 10,
  VehicleDisplays: 20,
  ApparelDisplays: 30,
  MultiUsageDisplays: 40,
  PartsAndService: 50,
  Furniture: 70,
  ExistingRacking: 90,
  CeilingElement: 100,
  LowCeilingHeader: 103,
  MerchandisingDisplay: 110,
  WallMountedSpecialDisplayAndTooling: 120,
  Design: 130,
  Graphic: 140,
  GeneralRackingItems: 200,
  FreeStandingFixtures: 210,
  HeaderOptions: 220,
  BackdropPanelOptions: 230,
  ShadowBoxOptions: 240,
  PrintOnDemand: 250,

  UnusedInventoryItems: -10,
};

export const InventoryItemCategoryEnum = [
  {
    value: InventoryItemCategoryEnumValue.NoCategory,
    name: 'NoCategory',
    labelFrench: 'Aucune catégorie',
    labelEnglish: 'No Category',
    category: CategoryEnumValue.Other,
  },
  {
    value: InventoryItemCategoryEnumValue.MerchandisingTooling,
    name: 'MerchandisingTooling',
    labelFrench: 'Marchandisage et outillage',
    labelEnglish: 'Merchandising & Tooling',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.VehicleDisplays,
    name: 'VehicleDisplays',
    labelFrench: 'Présentoirs de véhicule',
    labelEnglish: 'Vehicle Displays',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.ApparelDisplays,
    name: 'ApparelDisplays',
    labelFrench: 'Présentoirs de vêtements',
    labelEnglish: 'Apparel Displays',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.MultiUsageDisplays,
    name: 'MultiUsageDisplays',
    labelFrench: 'Présentoirs multi-usages',
    labelEnglish: 'MultiUsage Displays',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.PartsAndService,
    name: 'PartsAndService',
    labelFrench: 'Pièces et service',
    labelEnglish: 'Parts & Service',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.Furniture,
    name: 'Furniture',
    labelFrench: 'Meubles',
    labelEnglish: 'Furniture',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.ExistingRacking,
    name: 'ExistingRacking',
    labelFrench: 'Rayonnage existant',
    labelEnglish: 'Existing Racking',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.CeilingElement,
    name: 'CeilingElement',
    labelFrench: 'Élément de plafond',
    labelEnglish: 'Ceiling Element',
    category: CategoryEnumValue.Ceiling,
  },
  {
    value: InventoryItemCategoryEnumValue.LowCeilingHeader,
    name: 'LowCeilingHeader',
    labelFrench: "Options d'en-tête pour plafond bas",
    labelEnglish: 'Low Ceiling Header Options',
    category: CategoryEnumValue.Ceiling,
  },
  {
    value: InventoryItemCategoryEnumValue.MerchandisingDisplay,
    name: 'MerchandisingDisplay',
    labelFrench: 'Marchandisage et affichage',
    labelEnglish: 'Merchandising & Display',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.WallMountedSpecialDisplayAndTooling,
    name: 'WallMountedSpecialDisplayAndTooling',
    labelFrench: 'Présentoir spécial et outillage mural',
    labelEnglish: 'Wall Mounted Special Display and Tooling',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.Design,
    name: 'Design',
    labelFrench: 'Conception',
    labelEnglish: 'Design',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.Graphic,
    name: 'Graphic',
    labelFrench: 'Graphique',
    labelEnglish: 'Graphic',
    category: CategoryEnumValue.Other,
  },
  {
    value: InventoryItemCategoryEnumValue.GeneralRackingItems,
    name: 'GeneralRackingItems',
    labelFrench: 'Articles généraux de rayonnage',
    labelEnglish: 'General Racking Items',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.FreeStandingFixtures,
    name: 'FreeStandingFixtures',
    labelFrench: 'Luminaires autoportants',
    labelEnglish: 'Freestanding Fixtures',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.HeaderOptions,
    name: 'HeaderOptions',
    labelFrench: "Options d'en-tête",
    labelEnglish: 'Header Options',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.BackdropPanelOptions,
    name: 'BackdropPanelOptions',
    labelFrench: 'Options du panneau de toile de fond',
    labelEnglish: 'Backdrop Panel Options',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.ShadowBoxOptions,
    name: 'ShadowBoxOptions',
    labelFrench: "Options de la boîte d'ombre",
    labelEnglish: 'Shadow box Options',
    category: CategoryEnumValue.Wall,
  },
  {
    value: InventoryItemCategoryEnumValue.PrintOnDemand,
    name: 'PrintOnDemand',
    labelFrench: 'Impression sur demande',
    labelEnglish: 'Print-on-Demand',
    category: CategoryEnumValue.Other,
  },
  {
    value: InventoryItemCategoryEnumValue.UnusedInventoryItems,
    name: 'UnusedInventoryItems',
    labelFrench: 'Item disponible',
    labelEnglish: 'Available items',
    category: CategoryEnumValue.Other,
  },
];

export default InventoryItemCategoryEnum;
